<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">个人信息</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="lowerInfoContent">
            <div class="basicinfo ">
                <div class="title">
                    <img src="../../../static/flag.png" alt="">
                    <span>个人信息</span>
                </div>
                <div class="add-content">
                    <a-form :form="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
                        <a-form-item label="坐席类型">
                           <a-radio-group name="radioGroup" v-model="detail.gpid"  disabled >
                                <a-radio :value="item.gpid" :label="item" v-for="item in rolelist" :key="item.gpid">
                                {{item.title}}
                                </a-radio>
                            </a-radio-group>
                        </a-form-item>

                        <div v-if="detail.iskf==1">
                            <a-form-item label="CCSIPURL">
                                <a-input v-model="detail.ccsipurl" disabled
                                   placeholder="请输入CCSIPURL"
                                />
                            </a-form-item>
                            <a-form-item label="CC坐席工号">
                            <a-input v-model="detail.cc_id"
                                     placeholder="请输入CC坐席工号" disabled
                                />
                            </a-form-item>
                            <a-form-item label="CC坐席密码">
                                <a-input v-model="detail.cc_password" disabled
                                     placeholder="请确认CC坐席密码"
                                />
                            </a-form-item>
                            <a-divider />
                        </div>
                        


                        <a-form-item label="账号">
                            <a-input v-model="detail.username" auto-complete="off" disabled
                                placeholder="请输入账号"
                            />
                        </a-form-item>
                        <a-form-item label="手机">
                           <a-input v-model="detail.telephone" disabled
                                 placeholder="请输入手机号"
                            />
                        </a-form-item>
                        <a-form-item label="密码">
                           <a-input v-model="detail.password" type="password" auto-complete="new-password"
                                 placeholder="如果重新设置密码，请输入密码"
                            />
                        </a-form-item>

                        <a-form-item label="确认密码">
                            <a-input v-model="detail.password_t" type="password" auto-complete="new-password"
                                placeholder="请确认密码"
                            />
                        </a-form-item>
                        <a-form-item  label="所属项目">
                           <span v-if="detail.item_title">{{detail.item_title}}</span> 
                           <span v-else>暂无</span>
                        </a-form-item>

                        <a-form-item label="姓名">
                            <a-input v-model="detail.name"
                                 placeholder="请输入姓名"
                            />
                        </a-form-item>
                        <a-form-item label="开始时间">
                           {{detail.start_time | formatDate}}
                        </a-form-item>
                        <a-form-item label="结束时间">
                           {{detail.end_time | formatDate}}
                        </a-form-item>
                         <!-- <a-form-item label="是否显示手机">
                           <a-switch checked-children="是" un-checked-children="否" default-checked />
                        </a-form-item> -->
                    </a-form>
                </div>

                <div class="add-button">
                    <a-button icon="close-circle" theme="filled" @click="quitadd">取消</a-button>
                    <a-button icon="check-circle" type="primary" @click="saveuser" theme="filled">保存</a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment'
import {formatDate} from '../../utils/formate.js'
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            form: this.$form.createForm(this, { name: 'coordinated' }),
            locale,
            ccshow:false,

            detailid:"",
            detail:{item_title:"",imid:"",end_time:"",start_time:"",gpid:"",password:"",iskf:""},

            rolelist:"",
            projectlist:"",
            iskf:"",

            username:"",//用户名
            gpid:"",
            telephone:"",
            password:"",
            password_t:"",
            imid:"", //项目id
            name:"",
            start_time:"",
            end_time:"",
            ccsipurl:"",
            cc_id:"",
            cc_password:""

        }
    },
    mounted(){
        this.detailid=this.$route.query.id
        console.log(this.detailid)
        this.getrole()
        this.getproject()
        this.getdetail()
    },
    methods:{

        // 坐席详情
        getdetail(){
            this.$axios.post('/api/system/adminpage',{
 
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.detail=res.data.data
                    this.detail.password=""
                    if(res.data.data.iskf==1){
                        this.ccshow=true
                    }else{
                        this.ccshow=false
                    }
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        
        // 角色列表
        getrole(){
            this.$axios.post('/api/system/grouplist',{
                pagesize:100
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.rolelist=res.data.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 项目列表
        getproject(){
            this.$axios.post('/api/system/itemlist',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.projectlist=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 选择项目
        xmhandleChange(value){
            this.detail.imid=value
        },
        // 开始时间
        onstartChange(date, dateString){
            this.detail.start_time=moment(dateString).unix()
        },
        // 结束时间
        onendChange(date, dateString){
            this.detail.end_time=moment(dateString).unix()
        },


        // 取消
        quitadd(){
            this.$router.push({path:'/userlist'});
        },

        // 编辑
        saveuser(){
            console.log()
            if(this.password!=this.password_t){
                this.$message.warning("确认密码和密码不一致！"); 
            }else{
                if(this.detail.iskf==0){
                    this.$axios.post('/api/system/editadmin',{
                        aid:this.detail.aid,
                        username:this.detail.username,//用户名
                        gpid:this.detail.gpid,
                        iskf: this.detail.iskf,
                        telephone:this.detail.telephone,
                        password:this.detail.password,
                        password_t:this.detail.password_t,
                        imid:this.detail.imid, //项目id
                        name:this.detail.name,
                        start_time:this.detail.start_time,
                        end_time:this.detail.end_time,
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.$message.success(res.data.msg);
                            this.$router.push({path: '/userlist'});
                        }else{
                            this.$message.error(res.data.msg); 
                        }
                    
                    })
                }else{
                    this.$axios.post('/api/system/editadmin',{
                        aid:this.detail.aid,
                        username:this.detail.username,//用户名
                        gpid:this.detail.gpid,
                        telephone:this.detail.telephone,
                        password:this.detail.password,
                        password_t:this.detail.password_t,
                        imid:this.detail.imid, //项目id
                        name:this.detail.name,
                        start_time:this.detail.start_time,
                        end_time:this.detail.end_time,
                        ccsipurl:this.detail.ccsipurl,
                        cc_id:this.detail.cc_id,
                        cc_password:this.detail.cc_password
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.$message.success(res.data.msg);
                            this.$router.push({path: '/userlist'});
                        }else{
                            this.$message.error(res.data.msg); 
                        }
                    
                    })
                }
               
            }
            

        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/person.vue